var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgProduct = function SvgProduct(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.885 12.511a.889.889 0 0 1-1.622-.726l3.852-8.593a.888.888 0 1 1 1.622.727zm6.378-8.592a.89.89 0 0 1 1.622-.727l3.852 8.593a.889.889 0 0 1-1.622.726z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m15.89 9.778 1.226 2.733c.2.448.725.648 1.174.448a.89.89 0 0 0 .448-1.174l-.9-2.007h3.644c.656 0 1.185.53 1.185 1.185 0 .656-.53 1.185-1.185 1.185l-1.922 7.685c-.296 1.056-1.211 1.797-2.3 1.797H6.708c-1.056 0-2.004-.741-2.267-1.797l-1.922-7.685a1.185 1.185 0 1 1 0-2.37h3.645l-.9 2.007a.889.889 0 0 0 1.622.726l1.192-2.733z"
  })));
};
export default SvgProduct;